// Two small per-room memories for the material shelf, kept in the browser:
// what was auditioned or placed lately (Live's Browser has no "recent", and
// it is the first thing a phone wants — the thing you just used is the thing
// you want again), and which rows are starred (Live's Collections, reduced to
// one colour because a phone has one thumb).
//
// localStorage because this is a per-device convenience, not state the room
// owns: a star on one phone need not reach the laptop, and nothing here must
// survive a cleared site. Every read and write is guarded — private windows
// and blocked storage throw, and the shelf must render without them.

const RECENT_MAX = 30;

function read(key: string): string[] {
  try {
    const raw = localStorage.getItem(key);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

function write(key: string, value: string[]): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Nothing to do: the memory is a convenience.
  }
}

export function recentKey(roomId: string): string {
  return `seedbed.material.recent.${roomId}`;
}
export function favoritesKey(roomId: string): string {
  return `seedbed.material.favorites.${roomId}`;
}

/** Most recent first. */
export function loadRecent(roomId: string): string[] {
  return read(recentKey(roomId));
}

/** Pure: the ring after `key` was used. Newest first, no duplicates, capped. */
export function touchRecent(ring: readonly string[], key: string): string[] {
  return [key, ...ring.filter((k) => k !== key)].slice(0, RECENT_MAX);
}

export function saveRecent(roomId: string, ring: readonly string[]): void {
  write(recentKey(roomId), [...ring]);
}

export function loadFavorites(roomId: string): Set<string> {
  return new Set(read(favoritesKey(roomId)));
}

export function saveFavorites(roomId: string, favorites: ReadonlySet<string>): void {
  write(favoritesKey(roomId), [...favorites]);
}
